import { ErrorIndicator } from '@components/common/Error';
import { LoadingIndicatorLarge } from '@components/common/Loading';
import { ApprovalInfo } from '@data/course/approval/approval';
import { UserData } from '@ypp-portal/models/user/userData';
import firebase from 'firebase/app';
import 'firebase/firestore';
import React from 'react';
import { useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore';
import CourseInfoDisplay from '../display/CourseInfoDisplay';
import GenericReviewBox from './GenericReviewBox';
import { getInstructors } from './getInstructors';
import { ReviewBoxProps } from './reviewBoxProps';

const CurriculumReviewBox: React.FC<ReviewBoxProps> = ({ doc }) => {
  const docData = doc.data();

  const [instructors, loading, error] = useCollectionData<UserData>(getInstructors(docData));
  const [approvalInfo, approvalLoading, approvalError] = useDocumentData<ApprovalInfo>(
    docData.curriculumApprovalRef
  );

  if (loading || approvalLoading) {
    return <LoadingIndicatorLarge></LoadingIndicatorLarge>;
  }

  if (error || !instructors || approvalError || !approvalInfo) {
    console.log(approvalError);
    return <ErrorIndicator></ErrorIndicator>;
  }

  return (
    <GenericReviewBox
      approvalStatus={approvalInfo.status}
      approvalRef={docData.curriculumApprovalRef}
      createAnnouncement={() => ({
        title: `${docData.name}: Curriculum Status Update`,
        content: `# Curriculum Status Update
Hello, {username}, 
Please check your course info page for the latest update regarding your curriculum for ${docData.name}.`,
        created: firebase.firestore.Timestamp.now(),
        forRoles: [],
        forUsers: [...docData.instructorIds],
      })}
      renderInfo={() => <CourseInfoDisplay courseData={docData} instructorData={instructors} />}
    />
  );
};

export default CurriculumReviewBox;
